import { appDependencies } from "../AppDependencies";
import { EmployeeAbsenceStatus } from "./EmployeeAbsenceStatus";
import { ICalendarOverride } from "./ICalendarOverride";
import { IEmployeeGroupAbsences } from "../employeeGroups/IEmployeeGroupAbsences";
import { IEmployeeAbsenceService } from "./IEmployeeAbsenceService";
import { IEmployeeAbsences } from "./IEmployeeAbsenceInfo";
import { ICalendar } from "../calendars/ICalendar";

export class EmployeeAbsenceService implements IEmployeeAbsenceService {
    isAvailableStatus(employeeAbsenceStatus: EmployeeAbsenceStatus): boolean {
        return [EmployeeAbsenceStatus.Work, EmployeeAbsenceStatus.Idle, EmployeeAbsenceStatus.Meeting].includes(employeeAbsenceStatus);
    }
    getAbsenceForDay(date: Date, isChanged:boolean): Promise<IEmployeeAbsences> {
        return appDependencies.IEmployeeAbsenceRepository.getAbsenceForDay(date, isChanged);
    }
    getAbsence(dateFrom: Date, dateTo: Date): Promise<ICalendar[]> {
        return appDependencies.IEmployeeAbsenceRepository.getAbsence(dateFrom, dateTo);
    }
    getAbsenceForMonth(date: Date): Promise<ICalendar[]> {
        return appDependencies.IEmployeeAbsenceRepository.getAbsenceForMonth(date);
    }
    getAbsenceClass(employeeAbsenceStatus: EmployeeAbsenceStatus): string {
        switch (employeeAbsenceStatus) {
            case EmployeeAbsenceStatus.Absent: return "absent";
            case EmployeeAbsenceStatus.Work: return "work";
            case EmployeeAbsenceStatus.Customer: return "customer";
            case EmployeeAbsenceStatus.Home: return "home";
            case EmployeeAbsenceStatus.Idle: return "idle";
            case EmployeeAbsenceStatus.Meeting: return "meeting";
            case EmployeeAbsenceStatus.Tentative: return "tentative";
        }
    }

    async setInMeeting(minutesInMeeting: number): Promise<boolean> {
        return await appDependencies.IEmployeeAbsenceRepository.setInMeeting(minutesInMeeting);
    }

    async setMeetingOver(): Promise<any> {
        return await appDependencies.IEmployeeAbsenceRepository.setMeetingOver();
    }

    fillAbsencesOnGroupedEmployees(groupedEmployees: IEmployeeGroupAbsences[], employeeAbsences: IEmployeeAbsences): void {
        groupedEmployees.forEach((group: IEmployeeGroupAbsences) => {
            group.employees.forEach(employee => {
                employee.calendarEvents = []

                const employeeAbsenceInfo = employeeAbsences.calendars.filter((x: any) => x.id === employee.id)[0];
                if (employeeAbsenceInfo) {
                    employee.status = employeeAbsenceInfo.status;
                    employee.meetingEnd = employeeAbsenceInfo.meetingEnd;
                    employee.calendarEvents.push(...employeeAbsenceInfo.calendarEvents);
                }

            });
            group.available = group.employees.filter((a: any) => this.isAvailableStatus(a.status)).length;
            group.total = group.employees.length;
        });
    }

    saveEvent(event: ICalendarOverride): Promise<any> {
        return appDependencies.IEmployeeAbsenceRepository.saveEvent(event);
    }
    deleteEvent(eventOid: string): Promise<any> {
        return appDependencies.IEmployeeAbsenceRepository.deleteEvent(eventOid);
    }
}
